import { Placement as CCPlacement } from '@pizza-hut-us-development/client-core';
import { PlacementChoice } from '@/builders/pizza/dataTransformers/builderTypes';
import Placement from '../Placement';

function isHalfTopping(placement: PlacementChoice | CCPlacement | undefined): boolean {
  return placement?.toLowerCase() === Placement.LEFT || placement?.toLowerCase() === Placement.RIGHT;
}

export default isHalfTopping;
